module.exports = __webpack_public_path__ + "img/expostyle_9631_spring_green.a3977a1a.jpg";